import styles from "./ProductCell.module.less";
import type { UnitPriceItem } from "@/types/product";
import { useNavigate } from "react-router-dom";
import { image as imageUtil, utils, cal, productUtil } from "@/utils";
import { useCorpSettingStore, useCorpInfoStore } from '@/stores'
import { Image } from 'antd-mobile'
import React, { useEffect, useState } from "react";
import useRefState from '@/hooks/useRefState'

interface ProductCellProps {
  item: any;
  index: number;
  cellWidth: string;
}

interface Thumb {
  url: string;
  backupUrl?: string;
}

const { imgFormatter } = imageUtil;
const { to } = utils;

const ProductCell: React.FC<ProductCellProps> = (props) => {
  const navigate = useNavigate();
  const { corpSetting } = useCorpSettingStore();
  const { corpInfo } = useCorpInfoStore()
  const { accountId } = corpInfo
  const { currencySymbol, cloudStoreStockType, qualityPrecision, pricePrecision } = corpSetting;
  const { item, index, cellWidth } = props;
  const [lastImgUrl, setLastImgUrl] = useState<string>("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isMultiPrice, setIsMultiPrice, isMultiPriceRef] = useRefState<boolean>(false);
  const [thumbObj, setThumbObj] = useState<Thumb>({
    url: "",
  });
  const [chooseUnit, setChooseUnit] = useState<UnitPriceItem>({
    priceText: "",
    originPrice: 0,
    price: 0,
    linePrice: 0,
    unitRatio: 0,
  });

  const handleGoDetail = (productId: string) => {
    navigate(`/product/detail/${productId}`);
  };

  async function initThumb() {
    const { imageList, video } = item.cloudProduct;
    const imgUrl = (imageList && imageList[0]) || video;

    if (imgUrl === lastImgUrl) return;

    const [err, res] = await to(imgFormatter(imgUrl, 260));

    setLastImgUrl(imgUrl);
    setThumbObj({ url: err ? imgUrl : res });
  }

  // 根据默认单位索引取单位对象
  function initChooseUnit() {
    const currentChooseUnit = productUtil.setChooseUnit(item, isMultiPriceRef.current, cloudStoreStockType, qualityPrecision, pricePrecision);
    setChooseUnit(currentChooseUnit);
  }

  useEffect(() => {
    const { productStatus } = props.item.cloudProduct;

    setIsMultiPrice((productStatus & 128) === 128);
    initThumb();
    initChooseUnit();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item]);

  return (
    <div className={styles["product-item"]} key={index} onClick={() => handleGoDetail(item.cloudProduct.productId)}>
      <div className={styles["img-wrap"]} data-index={cellWidth} style={{ height: cellWidth }}>
        <Image
          src={thumbObj.url}
          fit="cover"
          height={cellWidth}
          className={styles["preview-img"]}
          lazy={true}
        ></Image>
      </div>
      <div className={styles["text-wrap"]}>
        <h3 className={styles["title"] + " ep-2"}>
          <span className={productUtil.getRecommendClass(item.cloudProduct)}>
            {productUtil.getRecommendTag(item.cloudProduct)}
          </span>
          {item.cloudProduct.productName || ""}
        </h3>
        <div className={styles["price-wrap"]}>
          <span className={styles["symbol"]}>{currencySymbol}</span>
          <span className={styles["price"]}>{accountId ? cal.moneyFormat(chooseUnit.priceText) : '***'}</span>
          {!!chooseUnit.priceUnitName && (<span className={styles["unit"]}>{chooseUnit.priceUnitName ? '/' + chooseUnit.priceUnitName : ''}</span>)}
        </div>
      </div>
    </div>
  );
};

export default ProductCell;
